export default function FooterLogo() {
  return (
    <div className="mt-6 flex justify-center">
      <a
        href="http://baptizosystems.co.za"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="/baptizo_systems.png"
          alt="Baptizo Systems Logo"
          className="w-32 hover:opacity-80 transition-opacity duration-300"
        />
      </a>
    </div>
  );
}
